import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import type { ContextWork } from './context'
import './open-items.css'

export const WORK_QUEUES = ['book', 'evidence', 'chase'] as const
export type WorkQueue = (typeof WORK_QUEUES)[number]
export const WORK_QUEUE_LABELS: Record<WorkQueue, string> = {
  book: 'Book',
  evidence: 'Evidence',
  chase: 'Chase',
}

/** Queue card counts; incomplete Book coverage is a loaded count only. */
export default function OpenItemsSummary({
  work,
  selected,
  onSelect,
  links,
  children,
}: {
  work: Pick<ContextWork, 'queues' | 'book_discovery_complete'> | null
  selected: WorkQueue | null
  onSelect: (queue: WorkQueue) => void
  links?: Record<WorkQueue, string>
  children?: ReactNode
}) {
  return (
    <div className="open-items-summary" aria-label="Work queues" aria-busy={!work}>
      {WORK_QUEUES.map((name) => {
        const count = work?.queues.find((queue) => queue.name === name)?.counts.card_count
        const incomplete = name === 'book' && work?.book_discovery_complete === false
        const label =
          WORK_QUEUE_LABELS[name] +
          (count == null
            ? ''
            : ': ' + count + ' ' + (incomplete ? 'loaded items; list incomplete' : 'open items'))
        const content = (
          <>
            <span>{WORK_QUEUE_LABELS[name]}</span>
            <strong>{count == null ? '—' : String(count) + (incomplete ? '+' : '')}</strong>
          </>
        )
        if (links)
          return (
            <Link
              key={name}
              className={'open-items-queue ' + name}
              to={links[name]}
              aria-label={label}
            >
              {content}
            </Link>
          )
        return (
          <button
            key={name}
            type="button"
            className={'open-items-queue ' + name + (selected === name ? ' selected' : '')}
            onClick={() => onSelect(name)}
            aria-pressed={selected === name}
            aria-label={label}
          >
            {content}
          </button>
        )
      })}
      {children}
    </div>
  )
}
